export function initBookFilter() {

  const buttons = document.querySelectorAll('.nav_books li');
  const books = document.querySelectorAll('.content.-books .s_book');

  if (!buttons.length) return;

  buttons.forEach(button => {

	button.addEventListener('click', () => {

	  const filter = button.dataset.filter;

	  books.forEach(book => {

		const labels = book.dataset.label.split(' ');

		if (labels.includes(filter)) {
			book.style.display = '';
		  book.classList.remove('is-hide');
		} else {
		  book.classList.add('is-hide');
		  setTimeout(()=>{
			  book.style.display = 'none';
			},350);
		}

	  });

	});

  });

}